const apiEndPoint = `${process.env.REACT_APP_DOCUMENT_SERVICE_URL}${process.env.REACT_APP_DOCUMENT_SERVICE_PORT}/${process.env.REACT_APP_DOCUMENT_SERVICE}/api/${process.env.REACT_APP_API_VERSION}/${process.env.REACT_APP_API_PRIVATE}/document`;

export const getFilePreviewURL = (documentId: string, fileId: string) =>
  `${apiEndPoint}/${documentId}/file/${fileId}`;

export const downloadFile = (documentId: string, fileId: string) =>
  `${apiEndPoint}/${documentId}/file/${fileId}?format=2`;
